export { TravellerDetailModal } from "./TravellerDetailModal";
